import { VerticalType } from '../types/cmsTypes';

// `satisfies Record<VerticalType, true>` keeps this in step with the union: a
// member added or removed there fails to compile here.
const VERTICAL_TYPES = {
  CREDIT_CARD: true,
  PERSONAL_LOANS: true,
  TRAVEL_INSURANCE: true,
  CAR_INSURANCE: true,
  INSURANCE: true,
  BANKING: true,
  INVESTMENTS: true,
  TELCO: true,
  PERSONAL_FINANCE: true,
  OTHERS: true,
  HOME_LOAN: true,
  E_WALLET: true,
  LIFESTYLE: true,
  GOVERNMENT_SERVICES: true,
  MONEY_MANAGEMENT: true,
  SPONSORED: true,
  ASSET_MANAGEMENT: true,
  HEALTH_INSURANCE: true,
  PET_INSURANCE: true,
  HOME_INSURANCE: true,
  MAID_INSURANCE: true,
  MOTORCYCLE_INSURANCE: true,
  SME: true,
  OFW: true,
  LIFE_INSURANCE: true,
} satisfies Record<VerticalType, true>;

/** Type guard for values that arrive as plain strings (URL hash, query params). */
export const isVerticalType = (value: unknown): value is VerticalType =>
  typeof value === 'string' &&
  Object.prototype.hasOwnProperty.call(VERTICAL_TYPES, value);
